import { arSA as base } from "./ar-SA";

const overrides = {
  formFieldInputPlaceholder__emailAddress: "أدخل بريدك الإلكتروني",
  formFieldInputPlaceholder__emailAddress_username: "أدخل بريدك الإلكتروني",
  formFieldInputPlaceholder__password: "أدخل كلمة المرور",
  formFieldInputPlaceholder__signUpPassword: "اختر كلمة مرور",
  formFieldInputPlaceholder__firstName: "الاسم",
  formFieldInputPlaceholder__lastName: "اللقب",
  formFieldInputPlaceholder__backupCode: "رمز احتياطي",
  formFieldInput__emailAddress_format: "صيغة البريد الإلكتروني غير صحيحة",
  signIn: { start: { titleCombined: "المتابعة إلى {{applicationName}}" } },
  signUp: { start: { subtitleCombined: "للمتابعة إلى {{applicationName}}" } },
  unstable__errors: {
    form_code_incorrect: "الرمز غير صحيح",
    form_password_incorrect: "كلمة المرور غير صحيحة",
    form_password_length_too_short: "كلمة المرور قصيرة جدا",
    form_param_nil: "هذا الحقل إجباري",
    form_param_format_invalid: "الصيغة غير صحيحة",
    form_param_type_invalid__email_address: "البريد الإلكتروني غير صالح",
    form_password_compromised__sign_in: "كلمة المرور هذه مسربة، يرجى إعادة تعيينها",
  },
};

const merge = (a, b) => {
  const out = { ...a };
  Object.entries(b).forEach(([k, v]) => { out[k] = v && typeof v === "object" ? merge(a[k] || {}, v) : v; });
  return out;
};

export const arTN = merge(base, overrides);
